<!-- begin:: Footer -->
<div class="footer bg-white py-4 d-flex flex-lg-column " id="kt_footer" [ngClass]="footerClasses">
	<div [ngClass]="footerContainerClasses" class=" d-flex flex-column flex-md-row align-items-center justify-content-between">
    <!--begin::Copyright-->
    <div class="text-dark order-2 order-md-1">
			<span class="text-muted font-weight-bold mr-2">{{today | date:'yyyy'}} &copy;</span>
      <a href="https://arpuplus.com/" target="_blank" class="text-dark-75 text-hover-primary">ARPUPLUS</a>
		</div>
    <!--end::Copyright-->

    <!--begin::Nav-->
    <div class="nav nav-dark order-1 order-md-2">
			<a href="https://arpuplus.com/the-company" target="_blank" class="nav-link pr-3 pl-0">About</a>
			<a href="https://arpuplus.com/work-with-us" target="_blank" class="nav-link px-3">Team</a>
			<a href="https://arpuplus.com/contact-us" target="_blank" class="nav-link pl-3 pr-0">Contact</a>
		</div>
	</div>
</div>
<!-- end:: Footer -->
